import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/shared/components/ui/Dialog';
import type { Signal } from '@momentum/types';

interface DeleteSignalDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  signal: Signal | null;
  isDeleting: boolean;
}

export const DeleteSignalDialog = ({
  open,
  onOpenChange,
  onConfirm,
  signal,
  isDeleting,
}: DeleteSignalDialogProps) => {
  const { t } = useTranslation('knowledge');

  if (!signal) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>{t('deleteSignalTitle')}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">
            {t('deleteSignalDescription')(signal.title)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            {t('deleteSignalCancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? t('deleteSignalDeleting') : t('deleteSignalConfirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
